
import { CharterDocumentation } from "../../components/charterDocument/charterDocument";
import { Sign } from "../../services/signature/signature";


/**
 * @function Charter display the coworking charter with the check sign buttons
 * @returns {JSX.Element} HTML content
 */
function Charter(properties: { isSigned: boolean }) {

    /* we retrieve the user's email */

    /* if the charter is unsigned, it displays the check and sign button */
    if (properties.isSigned) {
        return (
            <>
                <CharterDocumentation />
            </>
        );
    }
    return (
        <Sign />

    );
}

export { Charter };